import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAllApprovedLoans } from '../../../../services/financing';
import GTable from '../../../../components/elements/GTable';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';
import useRoute from '../../../../hooks/routesHook';
import Loan from '../../../../models/Loan';
import useLoans from '../../../../hooks/loansHook';



export const LoanSummaryTable: React.FC = () => {
  const [loans, setLoans] = useState<Loan[]>([]);
  const { getDashboardBase } = useRoute();
  const { columns } = useLoans({ showColumCheckbox: false });
  const navigate = useNavigate();

  const getApprovedLoans = async () => {
    try {
      const response: any = await getAllApprovedLoans(0, 5);
      if (response) {
        const unPaidLoans = response?.content.map((loan: any) => new Loan(loan)).filter((loan: Loan) => !loan?.paid);
        setLoans(unPaidLoans);
      }
    } catch (error) {
      console.error('Error fetching disbursement metrics:', error);
    }
  };

  const { isLoading } = useQuery({
    queryKey: ['getApprovedLoans'],
    queryFn: getApprovedLoans,
  })

  return (
    <div className="bg-white dark:bg-darkBg dark:border dark:border-darkBg-border shadow rounded-lg overflow-hidden">
      <div className="p-4 border-b border-gray-200 dark:border-darkBg-border">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-medium text-gray-900 dark:text-darkBg-mainText">New Applications</h3>
        </div>
      </div>

      <div className="overflow-x-auto">
        <GTable
          columns={columns}
          loading={isLoading}
          data={loans}
          classes="h-fit"
          showSearch={false}
          showCheckboxes={false}
          showPagination={false}
          tableType={'loan'}
          stickyHeader
        />

        {loans && loans.length > 5 && (
          <div className="flex justify-end mt-4 p-6">
            <Link to={`${getDashboardBase()}/loans`} className="text-blue-500 hover:underline"><span className="font-semibold">view more</span></Link>
          </div>
        )}
      </div>
    </div>
  );
};
